import * as Yup from 'yup';

export const CadastroDoacaoValidationSchema = Yup.object().shape({
	nome: Yup.string().trim()
		.required('Campo obrigatório')
		.max(100, 'Não deve ter mais que 100 caracteres'),
	tipoItemDoacao: Yup.object().shape({
		codigo: Yup.string().required('Campo obrigatório'),
	}),
	unidadeMedidaItemDoacao: Yup.object().shape({
		codigo: Yup.string().required('Campo obrigatório'),
	}),
	volume: Yup.string().trim().nullable().test(
		'volume',
		'Não deve ter mais que 6 dígitos',
		(val) => {
			if (val) {
				return val.length <= 8;
			}
			return true;
		},
	),
});
